module.exports = __webpack_public_path__ + "static/media/profile_placeholder_gray.fe5b658b.svg";